import { render } from "./mobile.vue?vue&type=template&id=5f00a4b0"
import script from "./mobile.vue?vue&type=script&lang=js"
export * from "./mobile.vue?vue&type=script&lang=js"

import "./mobile.vue?vue&type=style&index=0&id=5f00a4b0&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-listing-list/template4/components/recent-listings/mobile.vue'],['render',render],['__file',"mobile.vue"]])

export default __exports__